import {
  motion,
  useMotionValueEvent,
  useScroll,
  useSpring
} from "framer-motion";
import { useState, useRef, useEffect } from "react";
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import "./index.scss";

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    setStoryScrollY(latest);
    setStoryScrollInterval((storyScrollBot - storyScrollTop)/8);
  })

  const [storyScrollY, setStoryScrollY] = useState(0);
  const [storyScrollTop, setStoryScrollTop] = useState(0);
  const [storyScrollBot, setStoryScrollBot] = useState(0);
  const [storyScrollInterval, setStoryScrollInterval] = useState(0);
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [viewCount, setViewCount] = useState(0);

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    const storyElement = document.getElementById("story").getBoundingClientRect();
    const storyTop = storyElement.top;
    const storyBot = storyElement.bottom;
    const height = window.innerHeight;
    const width = window.innerWidth;
    const body = document.body.scrollHeight;
    const bodyScrolled = window.pageYOffset;

    setStoryScrollTop((storyTop + height + bodyScrolled)/body);
    setStoryScrollBot((storyBot + height + bodyScrolled)/body);
    setWindowWidth(width);
    setWindowHeight(height);
    
    axios.get(`https://api.vallencius.com/api/views/update/jennifer`)
    .then(res => {
      setViewCount(res.data);
    })
    .catch(function(error) {
      console.log(error);
    });
  }, []);

  const [selectedCity, setSelectedCity] = useState(0);
  const cities = [
      { label: 'Januari 2017', value: 0 },
      { label: 'Mei 2018', value: 1 },
      { label: 'Februari 2019', value: 2 },
      { label: 'September 2022', value: 3 },
      { label: 'Januari 2023', value: 4 },
      { label: 'Januari 2024', value: 5 },
  ];

  function checkAudioTime(index) {
    if (index !== 1 && audioRef.current.currentTime > 0) {
      return true;
    }
    if (index !== 2 && audioRef2.current.currentTime > 0) {
      return true;
    }
    if (index !== 3 && audioRef3.current.currentTime > 0) {
      return true;
    }
    if (index !== 4 && audioRef4.current.currentTime > 0) {
      return true;
    }

    return false;
  }

  // Reference to the audio element
  const audioRef = useRef(null);

  // Toggle play/pause
  const togglePlayPause = () => {
    audioRef.current.play();

    if (checkAudioTime(1)) {
      audioRef2.current.pause();
      audioRef3.current.pause();
      audioRef4.current.pause();
    }
  };
  
  // Reference to the audio element
  const audioRef2 = useRef(null);

  // Toggle play/pause
  const togglePlayPause2 = () => {
    audioRef2.current.play();

    if (checkAudioTime(2)) {
      audioRef.current.pause();
      audioRef3.current.pause();
      audioRef4.current.pause();
    }
  };
  
  // Reference to the audio element
  const audioRef3 = useRef(null);

  // Toggle play/pause
  const togglePlayPause3 = () => {
    audioRef3.current.play();

    if (checkAudioTime(3)) {
      audioRef.current.pause();
      audioRef2.current.pause();
      audioRef4.current.pause();
    }
  };
  
  // Reference to the audio element
  const audioRef4 = useRef(null);

  // Toggle play/pause
  const togglePlayPause4 = () => {
    audioRef4.current.play();

    if (checkAudioTime(4)) {
      audioRef.current.pause();
      audioRef2.current.pause();
      audioRef3.current.pause();
    }
  };

  return (
    <div className="w-full overflow-x-hidden">
      {
        viewCount !== 0 && <div className="fixed bottom-0 left-0 bg-white rounded-lg z-[99999] font-kanit px-4 py-1">Jumlah pengunjung: { viewCount }</div>
      }
      <motion.div 
        initial={{ opacity: 100 }}
        animate={{ 
          opacity: 0,
          transitionEnd: {
            display: "none",
          },
        }}
        transition={{
          opacity: { duration: 1.5, delay: 1.5 }
        }}
        className="fixed flex justify-center items-center bg-blue-100 w-screen h-screen z-[999]"
      >
        <img loading="lazy" src="../video/preloader.gif" className="w-48 h-48"/>
      </motion.div>
      <motion.div className="w-screen h-2 bg-red-500 fixed top-0 left-0 right-0 origin-top-left z-[100]" style={{ scaleX }} />
      <div className="fixed top-0 w-full min-h-full overflow-hidden inset-0 bg-black z-0">
        <iframe
          className="w-full h-full mx-auto z-50"
          src="https://drive.google.com/file/d/1iyhp_gYWzsYgBkn10_HnjwbiZmHuQ0PC/preview"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>

      {/* Section 1 */}
      <div className="w-full min-h-full bg-aqua-50 z-30">
        <div className="h-[100svh] relative flex flex-col justify-evenly items-center bg-aqua-50 z-50">
          <motion.div
            className="text-3xl px-4 sm:text-5xl mx-20 text-center z-10 teks-title drop-shadow-[0_0_70px_rgba(12,131,189,0.2)]"
            initial={{ opacity: 0, scale: 2 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 1.5 },
              scale: { duration: 1 }
            }}
          >
            <p className="popout font-kanit-semibold">
              <span>MENGEVALUASI </span>
              <span>MODA </span>
              <span>PENGANGKUT </span>
              <span>SAMPAH </span><br/>
              <span>DINAS </span>
              <span>LINGKUNGAN</span>
              <span>HIDUP</span><br/>
              <span>KOTA</span>
              <span>TANGERANG</span>

            </p>
          </motion.div>
          <img loading="lazy" src={"../image/bg3.png"} className="h-[10vh] opacity-0" alt="bg"/>
          <motion.img
            src={"../image/sun.png"} className="w-screen absolute top-0 xl:top-[-60vh] object-cover z-0" alt="bg"
            initial={{ opacity: 0, y: "-20vw", x: 0 }}
            whileInView={{ opacity: 1, y: 0, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 10 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg3.png"} className="w-full h-[30vh] xl:w-screen xl:h-auto absolute bottom-[-6px] object-cover" alt="bg"
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 1 }
            }}
          />
          <motion.img loading="lazy" src={"../image/orang4.png"} className="h-32 sm:h-48 absolute bottom-[-3px] z-30" alt="bg"
            initial={{ opacity: 0, x: "-20vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 5 }
            }}
          />
          <motion.img loading="lazy" src={"../image/orang3.png"} className="h-32 sm:h-44 absolute right-[10vw] sm:right-1/4 bottom-[-3px] z-30" alt="bg"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/mobil2.png"} className="hidden sm:block sm:h-44 absolute left-[5%] bottom-[-4px] z-20" alt="bg"
            initial={{ opacity: 0, x: "50vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 10 }
            }}
          />
        </div>
        <div className="w-full mb-[150vh] overflow-hidden relative flex items-center text-blue-600 bg-transparent z-30">

        </div>

        {/* Section 2 */}
        <div className="w-full min-h-screen overflow-hidden relative flex items-center text-blue-600 bg-gradient-to-b from-gold to-orange-300 z-30">
          {/* <div className="m-16 py-4 px-6 lg:m-8 font-kanit bg-aqua-50 rounded z-50">
            <h2 className="text-base sm:text-2xl font-kanit-semibold">
              Permasalahan
            </h2>
            <p className="text-xs sm:text-base">
              Sampah adalah Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed risus faucibus, posuere risus quis, lobortis nisi. Vestibulum eget orci vel est tempor feugiat et eget dui. Sed placerat tortor elit, ut semper nibh pulvinar a. Nam rhoncus turpis ipsum, vitae fringilla lectus dignissim at. Etiam aliquet elit at libero molestie, nec tempus ipsum feugiat. Donec interdum purus orci, in fringilla magna sollicitudin vulputate. Mauris egestas sem venenatis sagittis semper. Nulla id gravida diam, eu aliquam ex.
              <br/><br/>
              Fusce nec tempus dui. Vivamus feugiat at nunc ut elementum. Duis massa neque, commodo non mollis et, facilisis sed odio. Aenean tincidunt, sem vitae commodo tristique, ex enim facilisis tellus, eu feugiat ante libero id nunc. Nam at condimentum nisl. Curabitur a mi sed ipsum convallis luctus. Donec sodales sit amet dolor ut tincidunt. Phasellus at eros in augue ullamcorper bibendum quis sed diam. Nam eget nulla nec augue tincidunt molestie. Proin et felis eu ipsum fringilla efficitur a non metus.
              <br/><br/>
              Praesent fermentum, leo sit amet aliquet maximus, lacus ligula blandit mauris, vitae ultrices nisi elit vitae quam. Quisque rhoncus turpis enim, vel fringilla quam scelerisque et. Fusce feugiat elit et sem pharetra, facilisis ultrices dui fringilla. Pellentesque elementum dapibus mauris id volutpat. Etiam lacinia sodales purus ut feugiat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed feugiat nibh et massa sagittis pretium. Praesent tempus luctus porttitor.
            </p>
          </div> */}
          <div className="mt-16 py-4 px-6 lg:mt-8 font-kanit text-white z-50 mb-96 text-base md:text-lg text-justify max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Saya telah menjadi penduduk Kota Tangerang terhitung sejak 2005 yang berarti hampir dua dekade lalu. Perubahan demi perubahan telah saya lihat dan rasakan. Namun, ada salah satu permasalahan yang mungkin tidak akan pernah usai terlepas dari siapapun yang mengelola. Permasalahan yang saya maksud adalah sampah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Dilansir dari <a href="https://megapolitan.kompas.com/read/2013/06/13/17050267/Wali.Kota.Tangerang.Gusar.Kotanya.Dibilang.Kotor" target="_blank" rel="noreferrer"><u>Kompas.com</u></a>, Kota Tangerang pernah menyandang sebagai Kota Terkotor seluruh Indonesia pada 2006 silam. Namun, stigma tersebut perlahan berubah berkat kerja sama pihak pemerintah dan masyarakat hingga didapatkannya penghargaan Adipura atau penghargaan untuk kota-kabupaten yang berhasil dalam mengelola kebersihan dan lingkungan perkotaan secara berkelanjutan.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Terhitung sejak 2010, Kota Tangerang sudah menjadi langganan membawa pulang penghargaan Adipura. Hebatnya lagi, secara berturut 8 tahun yaitu 2010 hingga 2018, Kota Tangerang terus-menerus mendapatkan penghargaan tersebut. Seraya bosan atau lemari yang penuh untuk menampung penghargaan itu, Kota Tangerang sempat kecolongan di tahun 2019 hingga 2021.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Di sisi lain, bertepatan dengan hari milad yang ke-30 tahun, Kota Tangerang kembali memboyong penghargaan Adipura di 2023 lalu. Diberikan langsung oleh Menteri Lingkungan Hidup dan Kehutanan Republik Indonesia (LHK), Siti Nurbaya Bakar, Kota Tangerang diklaim sudah berhasil membangun 186 bank sampah dan tujuh TPS3R yang tersebar di 13 kecamatan.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8"><b>Namun, predikat Adipura yang didapatkan oleh Kota Tangerang apakah turut dirasakan juga oleh penduduknya?</b></motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Di beberapa titik, sering saya jumpai tumpukan sampah yang banyak. Saking banyaknya, sampah-sampah itu sampai menutupi jalan yang seharusnya jadi infrastruktur nyaman bagi penduduk sekitar. Bau yang ditimbulkan tidak usah dipertanyakan lagi karena setiap kali saya melewati jalan itu, hidung saya berhenti bernapas untuk sesaat. Anehnya, pengendara motor lain yang melewati jalan serupa tidak memperlihatkan mimik muka yang sama dengan saya.</motion.p>

            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/video1.mp4"/>
            </motion.video>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Bisa saya simpulkan, penduduk sekitar mungkin sudah berkawan dengan bau busuk itu. Jalan yang saya maksud adalah Jalan Cemara Raya, Cibodasari.</motion.p>

            <div className="flex flex-col md:flex-row justify-evenly z-50 mt-4 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/3 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/cibodasari1.jpg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/3 z-30"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 }
                }}
              >
                <img loading="lazy" src={"../image/cibodasari2.jpg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/3 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/cibodasari3.jpg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mt-8 mb-8">Terlihat, sampah menumpuk hingga air lindi yang dihasilkan oleh tumpukan sampah tersebut meresap hingga ke jalan. Oleh karena itu, jalan aspal menjadi sedikit berwarna gelap, walau sampah sudah diambil oleh truk sampah berjenis <i>dump truck</i>.</motion.p>

            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/dumptruck1.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/dumptruck2.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Jika saya amati, dulunya, jalan ini tidak digunakan sebagai Tempat Pembuangan Sementara (TPS). Namun, entah bagaimana, titik yang padat dilalui masyarakat ini dijadikan sebagai ‘TPS liar’. Tidak ada penyangga untuk membatasi sampah yang meluber hingga ke jalan. Pun, tidak ada penjaga atau petugas yang seharusnya berdiam di tempat untuk menegur masyarakat yang masih membuang sampah di sana.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Entah ‘TPS liar’ itu memang sesuai dengan kesepakatan masyarakat sekitar atau tidak. Namun, satu hal yang pasti, tidak ada penyuluhan atau solusi yang diusahakan oleh pihak terkait agar tumpukan sampah di ‘TPS Liar’ ini teratasi.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Dari tangkapan layar Google Maps, dahulu jalan ini merupakan kawasan yang cukup asri. Januari 2017, titik ini masih dipenuhi dengan tumbuhan hijau yang segar nan memanjakan mata. Kemudian, Mei 2018, tumbuhan hijau mulai digantikan dengan sampah dan puncaknya pada Februari 2019. Hanya berjarak sembilan bulan lamanya, titik ini sudah dipenuhi oleh sampah. Parahnya lagi, digenangi oleh air lindi.</motion.p>
          
            <motion.div className="w-[90%] sm:w-full mx-auto flex flex-col items-center mb-8 z-50"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                opacity: { duration: 2 }
              }}
              viewport={{ once: false }}
            >
              <div className="w-full text-center lg:text-2xl font-kanit-semibold">
                <Dropdown
                  value={selectedCity}
                  options={cities}
                  onChange={(e) => setSelectedCity(e.value)}
                  placeholder="Pilih Tanggal"
                  className="w-fit mx-auto px-6 py-1 text-blue-600 bg-blue-200 space-x-4 rounded-full"
                  style={{ borderWidth: "2px", borderColor: "rgb(12 131 189)" }}
                />
              </div>
              {
                selectedCity === 0 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                >
                  <img loading="lazy" src={"../image/Januari2017.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
              {
                selectedCity === 1 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                >
                  <img loading="lazy" src={"../image/Mei2018.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
              {
                selectedCity === 2 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                >
                  <img loading="lazy" src={"../image/Februari2019.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
              {
                selectedCity === 3 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                >
                  <img loading="lazy" src={"../image/September2022.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
              {
                selectedCity === 4 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                > 
                  <img loading="lazy" src={"../image/Januari2023.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
              {
                selectedCity === 5 &&
                <motion.div
                  className="w-full mx-auto mt-4 md:w-full z-30"
                  initial={{ opacity: 0, y: "20px" }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    opacity: { duration: 0.5 },
                    y: { duration: 1 }
                  }}
                >
                  <img loading="lazy" src={"../image/Januari2024.png"} className="mx-auto w-full px-4" alt="bg"/>
                  {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
                </motion.div>
              }
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Banyak penyebab yang membuat sampah menumpuk. Salah satu penyebab yang paling turut andil adalah armada pengangkut sampah yang tidak layak beroperasi.</motion.p>
          
            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/video2.mp4"/>
            </motion.video>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Saya penasaran dengan truk sampah Kota Tangerang. Kemudian, tidak pakai waktu lama, saya mencoba menyelam ke salah satu media sosial yang biasanya digunakan untuk berkicau tentang hal apapun.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Ketika saya mengetik kata kunci “Truk Sampah Kota Tangerang” muncul banyak komentar mengenai armada yang diandalkan untuk mengangkut sampah di Kota Tangerang. Masyarakat memberikan keluhannya terkait kemacetan, jam angkut, serta truk yang digunakan dinilai sudah usang.</motion.p>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Mereka bilang:</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="font-serif font-bold text-xl sm:text-3xl text-center w-3/4 mx-auto animate-wiggle"
            >
              “Masak jam segini truk mungut sampah 1/1 sepanjang jalan hanya muat 2 mbl barengan sama org berangkat kerja, sekolah dll, macet parah boss kenapa bukan malam?”
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="text-base text-center w-3/4 mx-auto mt-2"
            >
              <a href="https://twitter.com/luckyvdsaar_73/status/1704299214367490506" target="_blank" rel="noreferrer">
                <u>Cuit pemilik akun @luckyvdsaar_73, <br/>20 September 2023</u>
              </a>
            </motion.p>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="font-serif font-bold text-xl sm:text-3xl text-center w-3/4 mx-auto mt-8 animate-wiggleReverse"
            >
              “Truk sampah ini menambah kemacetan tiap pagi di pertigaan Pabuaran Indah krn mengambil sampah tdk pd waktu yg tepat,”
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="text-base text-center w-3/4 mx-auto mt-2"
            >
              <a href="https://twitter.com/goensant/status/1594839886150131713" target="_blank" rel="noreferrer">
                <u>komentar @goensant, <br/> 22 November 2022</u>
              </a>
            </motion.p>
          
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="font-serif font-bold text-xl sm:text-3xl text-center w-3/4 mx-auto mt-8 animate-wiggle2"
            >
              “Cuma patuh sehari aja perintah mu. Ini sudah mulai macet lagi gara2 truk angkut sampah di jam rawan macet. Gak serius ditangani.!”
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="text-base text-center w-3/4 mx-auto mt-2"
            >
              <a href="https://twitter.com/dimaskrisna38/status/1368723313518768132" target="_blank" rel="noreferrer">
                <u> tegas @dimaskrisna38,<br/> 08 Maret 2021</u>
              </a>
            </motion.p>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="my-8">Namun, di antara banyaknya celotehan yang saya temui, ada juga yang mengomentari tentang truk sampah berjenis <i>dump truck</i> yang digunakan untuk mengangkut sampah se-antero Kota Tangerang.</motion.p>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="font-serif font-bold text-xl sm:text-3xl text-center w-3/4 mx-auto mt-8 animate-wiggle"
            >
              “Min, sy lihat truk sampah ini di jln K.H. Hasyim Ashari arah kota Tangerang. Sedih amat lihatnya. Tanpa plat nomor, roda sudah gundul & goyang2. Takutnya ambruk n nimpa kendaraan di sebelahnya. Beli baru dong min bilang Pemkot. Kan kami bayar pajak terus,”
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="text-base text-center w-3/4 mx-auto mt-2"
            >
              <a href="https://twitter.com/rizki_ariesa/status/1519454571600683009" target="_blank" rel="noreferrer">
                <u>usul @rizki_ariesa yang resah melihat tampilan truk tak ber-identitas, 28 April 2022.</u>
              </a>
            </motion.p>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="my-8">Lainnya, saya juga melihat potongan video yang dipublikasi oleh <i>@mariaendahwu</i>, yang kemudian kembali dipublikasi ulang oleh <i>@AboutTNG</i>, pada 24 November 2023. Terlihat, <i>dump truck</i> yang sudah terisi penuh dengan sampah hingga ditambahkan dengan papan penyangga, sudah usang. Bahkan, hampir jatuh ke arah kanan.</motion.p>
            
            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[60vw] md:w-full md:h-[25vw] mx-auto z-50"
              autoPlay
              muted
              loop
            >
              <source src="../video/truk1.mp4"/>
            </motion.video>
            <motion.h3 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="text-center font-kanit text-base md:text-lg mb-8">sumber: Maria Endah</motion.h3>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Diselimuti oleh rasa penasaran yang cukup tinggi, saya datang menemui pemilik video itu. Jumat, 5 April 2024, tepat pukul 13.23 WIB, kami berjumpa.</motion.p>
            
            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/rusak1.jpg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>
          </div>
          <motion.img
            src={"../image/trash1.png"} className="w-60 absolute left-[5vw] top-[5%] object-cover z-30 opacity-25 md:opacity-100" alt="bg"
            initial={{ x: "-5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/trash2.png"} className="w-40 absolute right-[5vw] top-[17%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/trash3.png"} className="w-40 absolute left-[5vw] top-[26%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "-5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/trash4.png"} className="w-64 absolute right-[5vw] top-[37%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/trash5.png"} className="w-48 absolute left-[5vw] top-[48%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "-5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/annoyedSign1.png"} className="w-32 sm:w-48 absolute right-[10vw] top-[60%] sm:top-[55%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/annoyedSign2.png"} className="w-32 sm:w-48 absolute left-[15vw] top-[65%] sm:top-[62%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "-5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/annoyedSign3.png"} className="w-32 sm:w-48 absolute right-[10vw] top-[74%] sm:top-[70%] object-cover z-30 opacity-25 xl:opacity-100" alt="bg"
            initial={{ x: "5vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/pile1.png"} className="w-auto h-[40vh] sm:w-screen sm:h-auto absolute bottom-0 object-cover z-30" alt="bg"
            initial={{ opacity: 0, x: "5vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/pile2.png"} className="h-[40vh] sm:h-[80vh] absolute left-[-20vw] sm:left-[-10vw] xl:left-0 bottom-[-10px] z-30" alt="bg"
            initial={{ opacity: 0, x: "-5vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div>
        <div className="w-full min-h-screen overflow-x-hidden relative flex flex-col text-blue-900 bg-blue-100 z-30">
          <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
            <motion.div
              className="mx-auto mt-4 h-[50vh] md:h-[75vh] z-30"
              initial={{ opacity: 0, x: "8vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/MariaEndah.jpeg"} className="mx-auto h-full px-4" alt="bg"/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>
          </div>
          <div className="pb-4 px-6 font-kanit z-50 mb-96 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto border-l-8 border-blue-800">
            <motion.div
              className="ms-[-12%] sm:ms-[-7%] my-4 z-30 cursor-pointer"
              initial={{ opacity: 0, y: "5vw" }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                y: { duration: 2 }
              }}
            >
              <audio ref={audioRef}>
                <source src="../audio/namaSayaEndah.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause}/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Maria Endah namanya, kerap dipanggil Endah. Sejak dilahirkan pada 37 tahun silam, ia sudah menetap di Kota Tangerang. Sudah tidak asing lagi dengan truk sampah yang lalu-lalang setiap harinya, Endah mengaku ‘ngeri’ ketika melihat truk yang miring tersebut.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Yang kemarin itu bentuknya bak. Jadi, ‘kan bisa saja suatu saat copot terus <i>nimpa</i> orang yang di sebelahnya ‘kan, gitu,” Endah menjelaskan.</motion.p>
            
            {/* <motion.div
              className="ms-[-12%] sm:ms-[-7%] my-4 z-30 cursor-pointer"
              initial={{ opacity: 0, y: "5vw" }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                y: { duration: 2 }
              }}
            >
              <audio ref={audioRef9}>
                <source src="../audio/ngeri.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause9}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain kemiringan truk sampah yang sering kali dijumpai, Endah juga turut menyinggung soal beberapa masalah lain yang ia rasakan terkait truk pengangkut sampah milik Kota Tangerang ini.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8"><i>Pertama</i>, ia sering merasa kesusahan karena kemacetan yang diakibatkan oleh truk sampah yang sedang memungut sampah. Sama seperti warga media sosial lainnya yang sempat mengumpat karena kemacetan, nyatanya Endah juga termasuk.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Sering kali kemacetan ia rasakan ketika ingin berangkat ke kantor setiap paginya. Ketika melewati jalan tikus agar lebih cepat sampai ke tempat bekerjanya, ia malah bertemu dengan truk sampah yang sedang mengangkut sampah di jalan yang tergolong kecil tersebut.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Karena dia (truk) ‘kan berhenti dengan ngabisin satu jalan, sedangkan itu dua jalur saja sudah mepet banget ‘kan mobil. Nah dengan ada truk, otomatis di belakangnya akan berhenti. Harusnya jangan kayak gitu, jangan pakai truk yang besar, harusnya pakai truk yang lebih kecil gitu,” kata Endah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8"><i>Kedua</i>, masalah air lindi yang menetes dari bak sampah yang sudah bolong. Sudah pasti, ketika berada di belakang truk yang mungkin tampilannya agak <i>acak adut</i>, Endah sungkan untuk membuka kaca kendaraan roda empatnya.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Kalau kita di belakangnya <i>gak</i> mungkin, jangan sampai buka kaca, jangan sampai ngelewatin si bekas airnya kalau <i>gak</i> bakal nempel di mobil ‘kan,” imbuhnya.</motion.p>
            
            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "8vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/jelek1.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/jelek2.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Endah menilai, ketika air lindi tersebut bercucuran di jalan raya, tentunya kuman akan ikut tersebar. Padahal, masyarakat sudah memiliki tempat sampah atau wadah khusus yang digunakan untuk menampung sampah agar airnya tidak bercecer di tempat lain. Ia, pernah merasakan dampaknya secara langsung.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Pernah, mobil mungkin karena di belakangnya (truk). Jadi, mungkin dia <i>gak</i> tahu <i>kelibet</i> di ban atau ciprat lagi ke mesin, kok mobil bau banget gitu sih palingan. Akhirnya, ya sudah, pulang cuci mobil dulu. Air sampahnya nempel di roda,” cerita Endah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Merasa kecewa dengan pelayanan dan komunikasi yang diberikan, Endah mengeklaim pengangkutan sampah di Kota Tangerang masih kurang baik.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Kalau ke pemerintah sendiri <i>gak</i> tahu harus kemana karena kalau dari truk sampah sendiri kurang kali ya <i>woro-woronya</i>. Harus diinformasikan kemana karena kalau di truk sampah kayaknya <i>gak</i> ada tulisan pengaduan segala macam,” sebut Endah tentang kurangnya komunikasi dari pihak pemerintah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Menurut Endah, dari sudut pandang warga, terdapat beberapa solusi yang mungkin bisa menyelesaikan permasalahan tersebut. Sekiranya, ketika mengangkut di jalan yang kecil, truk yang digunakan adalah armada yang berukuran lebih kecil dari biasanya agar tidak menghadang mobil-motor yang berlalu-lalang di sana.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Kemudian, harapannya sih lebih ke armadanya aja diperbarui supaya airnya <i>gak</i> netes-netes dan <i>gak</i> sampai miring. Terus kalau bisa juga ada tutupnya jadi baunya <i>gak</i> kemana-mana,” kata Endah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Namun, jika truknya tidak memungkinkan untuk diperbaiki atau beli yang baru, setidaknya dasar dari bak sampah itu diberikan lapisan anti air agar tidak ada air lindi yang bisa mengalir keluar.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Endah berharap usai keluhannya diutarakan, pihak terkait akan mengambil tindakan tegas yang solutif. Terlepas dari dua masalah yang disebutkan oleh Endah, ia juga mengharapkan keamanan atau <i>safety</i> para pekerja yang biasa disebut dengan kernet.</motion.p>
            
            {/* <motion.div
              className="ms-[-12%] sm:ms-[-7%] my-4 z-30 cursor-pointer"
              initial={{ opacity: 0, y: "5vw" }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                y: { duration: 2 }
              }}
            >
              <audio ref={audioRef}>
                <source src="../audio/Endahmacet.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause}/>
            </motion.div> */}

            {/* <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="">Kemudian, jika truknya tidak memungkinkan untuk diperbaiki atau beli yang baru, setidaknya dasar dari bak sampah itu diberikan lapisan anti air agar tidak ada air lindi yang bisa mengalir keluar.</motion.p>
            
            <motion.div
              className="ms-[-12%] sm:ms-[-7%] my-4 z-30 cursor-pointer"
              initial={{ opacity: 0, y: "5vw" }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                y: { duration: 2 }
              }}
            >
              <audio ref={audioRef2}>
                <source src="../audio/antiair.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause2}/>
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Endah berharap usai keluhannya diutarakan, pihak terkait akan mengambil tindakan tegas yang solutif. Terlepas dari dua masalah yang disebutkan oleh Endah, ia juga mengharapkan keamanan atau safety para pekerja yang biasa disebut dengan kernet.</motion.p> */}
          </div>
          <motion.img loading="lazy" src={"../image/annoyed2.png"} className="h-32 sm:h-72 absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/annoyed1.png"} className="h-32 sm:h-72 absolute right-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img
            src={"../image/bg6.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div>

        <div className="w-full min-h-screen  relative flex justify-center text-blue-600 bg-green-100 z-30">
          <div className="mt-16 py-4 px-6 lg:mt-8 font-kanit z-50 mb-96 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Kernet yang bertugas untuk mengangkut sampah dari bawah ke truk duduk di atas baknya. Tidak menggunakan pengaman, kernet yang bertugas hanya mengandalkan kekuatan tangan berpegangan pada besi-besi di pinggir truk.</motion.p>
            
            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/kenek1.mp4"/>
            </motion.video>
            
            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/kenek2.mp4"/>
            </motion.video>
            
            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/kenek3.mp4"/>
            </motion.video>
          </div>

          <motion.img loading="lazy" src={"../image/mobil3.png"} className="h-[15vw] absolute left-[10vw] bottom-[5.8vw] z-30" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/mobil5.png"} className="h-[15vw] absolute right-[10vw] bottom-[2vw] z-30" alt="bg"
            initial={{ opacity: 0, x: "-50vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img
            src={"../image/bg7.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div>

        <motion.div 
          className="sticky top-0 bg-blue-100 rounded-lg px-4 py-2 h-[400vh] w-screen"
          id="story"
        >
          <div className="mt-16 py-4 px-6 lg:mt-8 font-kanit z-50 mb-96 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 6)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 9)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story6.webp"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 5)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 6)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story5.webp"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 4)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 5)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story4.webp"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 3)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 4)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story3.gif"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 2)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 3)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story2.webp"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.img initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * -3)) && storyScrollY <= (storyScrollTop + storyScrollInterval * 2) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} src={"../image/story1.png"} className="max-h-[50vh] max-w-[50vw] fixed inset-0 m-auto" />
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * -3)) && storyScrollY <= (storyScrollTop + storyScrollInterval * 2) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Sebelumnya, kejadian naas pernah menimpa seorang kernet yang sedang bertugas. Nur Ali namanya, yang sudah bekerja kurang lebih 5 hingga 6 tahun di Dinas Lingkungan Hidup Kota Tangerang sebagai kernet.</motion.p>
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 2)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 3)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Pada 16 Januari 2023, Ia terjatuh dari truk sampah dengan nomor polisi B-9201-COQ. Sopir yang bertugas, AM, mengangkut dua orang kernet. Satu di kursi penumpang sedangkan Nur Ali duduk manis di atas bak sampah.</motion.p>
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 3)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 4)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Saat itu, waktu menunjukkan 11.30 WIB dan sedang melintas di Jalan KH Hasyim Ashari dari arah Kota Tangerang menuju Ciledug.</motion.p>
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 4)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 5)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Menurut informasi yang didapat dari <a href="https://megapolitan.kompas.com/read/2023/01/16/16353201/kronologi-kernet-tewas-usai-jatuh-dari-truk-pengangkut-sampah-di" target="_blank" rel="noreferrer"><u>Kompas.com</u></a>, supir yang sedang bertugas saat itu diberi tahu oleh seseorang yang tidak dikenal bahwa ada yang terjatuh dari bak truk. Sontak, supir truk langsung berhenti dan menerka-nerka yang jatuh dari baknya itu.</motion.p>
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 5)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 6)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Ternyata, Nur Ali yang mungkin sedang menikmati enaknya angin di tengah siang, sudah terkapar di aspal dengan mengalami luka parah di bagian kepala dan langsung tewas di tempat. Oleh karena itu, jenazah Nur Ali langsung dibawa ke RSUD Kabupaten Tangerang.</motion.p>
            <motion.p initial={{ opacity: 0, display: "none" }} animate={ storyScrollY > (storyScrollTop + (storyScrollInterval * 6)) && storyScrollY <= (storyScrollTop + (storyScrollInterval * 9)) ? { display: "block", transitionEnd: { opacity: 1 } } : { opacity: 0, transitionEnd: { display: "none" } }} transition={{  opacity: { duration: 0.5 } }} className="fixed top-[5vh] inset-x-0 mx-auto w-[78vw] md:w-[800px] text-green-900 border-2 border-green-600 bg-green-100 rounded-lg px-4 py-2">Ali, meninggalkan lima orang anak.</motion.p>
            </div>
        </motion.div>

        {/* Section */}
        <div className="w-full min-h-screen sm:min-h-[130vh] overflow-hidden relative flex justify-center text-blue-600 bg-[#c3eefe] z-30">
          <div className="mt-16 py-4 px-6 lg:mt-8 font-kanit z-50 mb-[30vw] md:mb-[35vw] text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Berangkat dari berita yang saya baca, terenyuh hati saya untuk menemui salah satu pekerja kernet truk sampah Dinas Lingkungan Hidup Kota Tangerang. Tidak ingin namanya disebutkan karena takut dibebas-tugaskan oleh pihak terkait, saya penasaran dengan kegiatannya selama bertugas sebagai kernet.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Ia menuturkan, jam kerja biasanya tidak menentu karena saling tunggu dengan teman yang ikut bertugas. Biasanya, dari jam 5 mereka sudah berkumpul. Pun, untuk jam pulangnya juga tidak menentu.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Pria berumur kepala 3 tersebut mengatakan bahwa jumlah kernet tiap-tiap truk sampah tidak menentu. Ada yang tiga, ada pula yang empat. Namun, tidak menutup kemungkinan truk sampah hanya diisi oleh dua orang kernet.</motion.p>

            {/* <motion.div
              className="my-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef3}>
                <source src="../audio/AdaYang3.mp4" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause3}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Untuk keselamatan kerjanya saat bertugas, ia hanya mengandalkan fokus yang sudah terlatih selama bekerja sebagai kernet truk sampah. Duduk di atas bak sampah harus menghafal jalan yang dilalui dan juga mata harus tetap melihat ke depan.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Jika keasyikan berbicara dengan teman kernet lainnya, siap-siap kepala akan terhantam dengan ranting pohon ataupun kabel listrik.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Kalau di atas ‘kan ngerinya ada kabel, pohon. Sering saya di atas kena pohon kalau lupa sudah, ada yang kena pohon, kena rantingnya,” ia bercerita.</motion.p>

            {/* <motion.div
              className="my-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef4}>
                <source src="../audio/kenaRanting.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause4}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Sementara itu, terkait dengan pakaian yang digunakan, kernet tersebut mengaku perlengkapan seperti sarung tangan dan sepatu boot harus dibelinya sendiri. Tidak ada alasan yang jelas, pihak Dinas Lingkungan Hidup Kota Tangerang tidak lagi memberikan fasilitas <i>safety</i> tersebut. Padahal, dulu sempat diberikan kepada tiap-tiap kernet. Satu kernet mendapatkan satu pasang sepatu boot.</motion.p>

            {/* <motion.div
              className="my-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef5}>
                <source src="../audio/sepatuBot.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause5}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain mengangkut sampah, diketahui kernet juga memiliki tugas lain untuk menjahit terpal yang digunakan untuk menutupi sampah ketika sudah penuh di baknya.</motion.p>

            {/* <motion.div
              className="my-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef6}>
                <source src="../audio/kenekJahitin.mp3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause6}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Terkait perawatan armadanya, truk sampah yang digunakan setiap hari itu jarang sekali dicuci. Bahkan, mereka juga sudah lupa waktu terakhir kali truknya diservis.</motion.p>

            {/* <motion.div
              className="my-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef7}>
                <source src="../audio/andiKagakCuci.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause7}/>
            </motion.div> */}

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8"><b>“Kagak, susah airnya. Lihat saja bannya, boro-boro mau nyuci, pulangnya aja malam mulu, buangan macet,”</b> ucap kernet lainnya yang baru berusia 23 tahun.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Terhalang oleh ketersediaan air bersih di TPA Rawa Kucing membuat sopir kesulitan untuk membersihkan armadanya. Selain itu, fasilitas untuk mencuci armada yang disediakan juga sudah sirna karena kondisi TPA Rawa Kucing yang sudah <i>overload</i> sehingga fasilitas pencucian itu dijadikan tempat penampungan sampah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Jika kita bandingkan dengan DKI Jakarta yang lokasi pembuangannya di TPST Bantargebang, tentu akan jomplang. Pasalnya, semua truk sampah yang selesai membuang sampah, melewati fasilitas pencucian dulu agar kendaraan tetap terawat, terbebas dari air lindi, dan menghindari korosi.</motion.p>

            <motion.video 
              initial={{ opacity: 0 }} 
              whileInView={{ opacity: 1 }} 
              transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }}
              className="w-[80vw] h-[50vw] md:w-full md:h-[25vw] mx-auto z-50 mb-8"
              autoPlay
              muted
              loop
            >
              <source src="../video/pencucian.mp4"/>
            </motion.video>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Oleh sebab itu, truk sampah yang jarang dicuci atau perawatan lainnya, banyak truk sampah Kota Tangerang yang terlihat sudah usang. Bak untuk menampung sampah terlihat bolong akibat korosi sehingga air lindi jatuh ke jalan, roda yang digunakan terlihat botak, dan terkadang nomor polisi saja tidak ada.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain itu, terpal yang digunakan juga banyak yang sudah bolong sehingga sampah kembali terbang dan jatuh ke jalan raya.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Iya, terpal yang <i>ono</i> sudah sobek. Katanya gantinya belum ada. Terpalnya belum ada,” celotehnya.</motion.p>

            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/terpal1.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/terpal2.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/terpal3.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/terpal4.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Gambar di atas merupakan truk sampah yang saya temui di jalan. Nyatanya, tidak hanya truk tersebut saja yang kondisinya usang. Masih ada truk sampah lain yang kondisinya bahkan jauh lebih buruk dari yang saya temui. Hal ini pun diketahui dari foto yang diberikan oleh salah satu informan yang tidak ingin disebutkan namanya.</motion.p>
                
            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/kedaung1.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/kedaung2.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Saya bingung, apakah truk sampah Kota Tangerang memang sebanyak dan serusak itu? Diikuti dengan rasa keingintahuan yang cukup tinggi, saya pergi ke Jalan Iskandar Muda yang terletak di Kecamatan Neglasari untuk melakukan observasi selama satu jam.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Pemilihan jalan ini karena semua truk sampah pasti melalui jalan ini, baik untuk datang maupun pergi dari TPA Rawa Kucing. Saya berdiri di pertigaan, mengamati dari pukul 09.30 WIB hingga 10.30 WIB.</motion.p>

            <div className="flex flex-col md:flex-row justify-evenly z-50 mb-8 md:mt-12">
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "-10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/jalan1.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
              <motion.div
                className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
                initial={{ opacity: 0, x: "10vw" }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  type: "spring",
                  opacity: { duration: 0.5 },
                  x: { duration: 4 }
                }}
              >
                <img loading="lazy" src={"../image/jalan2.JPG"} className="mx-auto w-full px-4" alt="bg"/>
                {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
              </motion.div>
            </div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Dari hasil observasi saya selama 60 menit tersebut, saya mendapati sebanyak 41 truk sampah yang melintas. Namun, jumlah truk sampah yang memiliki bak sampah bolong, terpal rusak, dan truk usang ada 24 truk.</motion.p>

            <iframe 
              src='https://flo.uri.sh/visualisation/17863942/embed'
              title='Interactive or visual content'
              className='flourish-embed-iframe rounded-xl mb-8'
              frameborder='0'
              scrolling='no'
              style={{ width: '100%', height: '600px' }}
              sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
            </iframe>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Melihat kondisi truk sampah Kota Tangerang yang mengkhawatirkan, pasti banyak dampak yang dirasakan.</motion.p>
          </div>

          <motion.img loading="lazy" src={"../image/sampah3.png"} className="h-[10vw] absolute right-[10vw] bottom-[5vw] z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.5 },
              y: { duration: 0.5, delay: 1.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/sampah2.png"} className="h-[10vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.6 },
              y: { duration: 0.5, delay: 1.6 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/sampah4.png"} className="h-[10vw] absolute left-[40%] transform -translate-x-1/2 bottom-[7vw] z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.7 },
              y: { duration: 0.5, delay: 1.7 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg8.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div>

        {/* Section */}
        <div className="w-full min-h-screen overflow-hidden relative flex flex-col justify-center text-blue-600 bg-blue-100 z-30">
          <motion.h1 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="font-kanit-semibold text-center text-lg lg:text-3xl mt-12 mx-4">MIRZA SHAHREZA, PENGAMAT LINGKUNGAN</motion.h1>
          
          <motion.div
            className="w-[90%] mx-auto mt-4 md:w-1/2 z-30"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          >
            <img loading="lazy" src={"../image/MirzaShahreza.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
            {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
          </motion.div>

          <div className="mt-16 px-6 lg:mt-8 font-kanit z-50 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto border-l-8 border-blue-800">
            <motion.div
              className="ms-[-12%] sm:ms-[-7%] mb-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef2}>
                <source src="../audio/MirzaShahreza.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause2}/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Mirza Shahreza, seorang yang paham betul terkait lingkungan. Menurutnya, manajemen Dinas Lingkungan Hidup Kota Tangerang sebenarnya sudah baik karena setiap kelurahan terdapat suku dinas yang menangani. Namun, metode yang dianut masih salah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Tapi memang polanya masih konvensional. Maksudnya, ‘kan cuman diangkut, masyarakat buang,” kata Mirza, sapaannya. Dengan kata lain, sampah yang diangkut dari seluruh Kota Tangerang hanya dikumpulkan di Tempat Pembuangan Akhir (TPA) Rawa Kucing, tidak ada proses lebih lanjut untuk mengurangi tumpukan sampah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Demikian pula terkait kesiapan armadanya. Mirza mengeklaim walau sudah memiliki anggaran yang masif dan memiliki jadwal pengangkutan, tetapi truk yang digunakan sangat tidak masuk ke dalam standar.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Pasalnya, truk yang digunakan untuk mengangkut sampah di Kota Tangerang bukanlah truk pengangkut sampah yang semestinya. Jika dilihat lebih rinci, truk yang digunakan untuk mengangkut pasir adalah armada yang serupa dengan yang digunakan untuk mengangkut sampah. Oleh sebab itu, truk sampah sangat jauh dari kata standar.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Truk pasir itu ‘kan <i>gak</i> standar kayak truk yang mengangkut sampah ‘kan benar-benar masuk, ada suatu sistem yang menjaga supaya dia <i>gak</i> keluar,” imbuh Mirza.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Menurut Mirza, jika berstandar, truk sampah seharusnya tertutup dan memiliki sistem yang menjaga sampah itu tidak lagi keluar atau meneteskan air lindi. Namun, kebanyakan truk yang mengangkut sampah justru melambung ketika penuh karena ditambahkan oleh triplek-triplek.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Pada akhirnya truk yang tidak memiliki standar tersebut akan membuat sampah berceceran yang jatuh di jalan dan meneteskan air lindi.</motion.p>
          </div>

          <div className="mt-16 pb-4 px-6 lg:mt-16 font-kanit z-50 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8 px-4 py-2 rounded-xl border-blue-700 border-4 bg-blue-50">Berdasarkan informasi yang didapat dari Standar Nasional Indonesia, alat pengangkut sampah harus dilengkapi dengan penutup sampah, minimal dengan jaring, tinggi bak maksimum 1,6 meter, sebaiknya ada alat ungkit, kapasitas disesuaikan dengan kelas jalan yang akan dilalui, dan bak truk/dasar kontainer sebaiknya dilengkapi pengaman air sampah.</motion.p>
            
            <motion.div
              className="w-[90%] mx-auto mt-4 md:w-full z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/1,6m.png"} className="mx-auto w-full px-4" alt="bg"/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>
          </div>

          <div className="mt-16 pb-4 px-6 lg:mt-8 font-kanit z-50 mb-96 text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto border-l-8 border-blue-800">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Air lindi yang menetes ke jalan raya jika dalam jumlah yang banyak akan menimbulkan pencemaran lingkungan dan pencemaran udara terkait dengan bau yang tidak sedap. Pun demikian, air lindi memiliki potensi untuk mencelakakan pengendara motor. Oleh sebab itu, mendekati TPA Rawa Kucing, banyak peringatan untuk pengendara yang melintas.</motion.p>
          
            <motion.div
              className="w-[90%] mx-auto mt-4 md:w-1/2 z-30 mb-8"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/awasLicin.JPG"} className="mx-auto w-full px-4" alt="bg"/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain berbicara mengenai truk sampah, Mirza juga menyinggung pakaian yang digunakan oleh para pekerja. Ia menilai pakaian yang digunakan oleh mereka tidak memiliki standar yang seharusnya dipatuhi oleh pihak terkait. Walaupun memiliki kostum atau seragam, pakaian yang digunakan tidak menjamin pekerja terbebas dari penyakit karena sampah yang telah membusuk.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“<i>Gak</i> perlu harus kayak tebal kayak luar negeri, minimal tuh harus higienis yang standard kebersihannya, istilahnya kelayakan secara estetika juga kita bisa mengenali itu tugas resmi. Jadi, ada penghormatan terhadap profesi,” ucapnya.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Menurut Mirza, langkah-langkah yang harus diambil oleh pihak pemerintah terkait air lindi yang menetes adalah memastikan sampah yang diangkut dilakukan dengan cara disiplin, dalam arti tidak berhari-hari. Selain itu, truk sampah yang digunakan harus memiliki standar agar bisa meminimalisasi tetesan air lindi. Jika menggunakan truk pasir untuk mengangkut sampah, setidaknya di-desain sedemikian rupa agar tidak meneteskan air lindi.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Sementara itu, agar kendaraannya terhindar dari korosi, sebaiknya setiap kali selesai membuang sampah ke TPA Rawa Kucing, truk harus dibersihkan dengan cara disemprot dengan air bersih. Jangan dibiarkan sampai 3 hingga 4 hari.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Mirza berharap, kedepannya truk pengangkut sampah harus disiapkan agar punya kelayakan sesuai Standar Nasional Indonesia. Maksud Mirza, kendaraan yang disiapkan adalah kendaraan khusus mengangkut sampah, bukan untuk fungsi lain.</motion.p>
          </div>

          <motion.img loading="lazy" src={"../image/orang8.png"} className="w-[80vw] h-auto md:h-[15vw] md:w-auto absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1 },
              x: { duration: 0.5, delay: 1 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg9.png"} className="h-[30vh] w-auto md:w-screen md:h-auto absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div>

        {/* Section */}
        <div className="min-h-screen md:min-h-[130vh] flex flex-col items-center relative text-orange-700 bg-orange-100">
          <div className="mt-16 pb-4 px-6 lg:mt-8 font-kanit z-50 mb-48 md:mb-[600px] text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8 px-4 py-2 rounded-xl bg-orange-50 border-2 border-orange-500">Lantas, bagaimana tanggapan pengamat transportasi terkait masalah ini?</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8 text-center font-bold">DJOKO SETIJOWARNO, PENGAMAT TRANSPORTASI</motion.p>
            
            <motion.div
              className="w-[90%] mx-auto mb-8 md:w-1/2 z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/Djoko.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.div
              className="mb-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef3}>
                <source src="../audio/Djoko.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause3}/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>
            
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Aktif dalam berbagai forum yang berhubungan dengan transportasi baik itu di Pusat, Kementerian Perhubungan, Badan Usaha Milik Negara, dan juga Dinas Perhubungan Daerah, Djoko Setijowarno adalah orang yang tepat untuk berbicara mengenai permasalahan truk sampah di Kota Tangerang.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Menurutnya, truk sampah yang digunakan berbeda jauh dengan yang digunakan di luar negeri karena proses angkut yang digunakan di kota-kota Indonesia hanya asal angkut saja, tidak memerhatikan detail yang seharusnya diperhatikan, sesuai dengan Standar Nasional Indonesia.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Jika dibandingkan dengan truk sampah yang digunakan di luar negeri, misalnya di Arab Saudi, truk sampah yang digunakan oleh Indonesia, khususnya di Kota Tangerang memang cukup berbeda.</motion.p>

            <motion.div
              className="w-[90%] mx-auto mt-4 md:w-1/2 z-30 mb-8"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/trukMekah.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
              <h3 className="text-center font-kanit text-base md:text-lg">Sumber: Djoko Setijowarno</h3>
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Beberapa permasalahan yang berkaitan dengan truk sampah mengesalkan Djoko. Ia mengkritisi bahwa banyak truk di Indonesia tidak menggunakan jaring atau terpal untuk menutupi sampah yang telah terkumpul di bak. Kondisi truk yang digunakan untuk mengangkut juga tidak dalam kondisi yang bersih dan jalur yang dilewati truk sampah menuju TPA tidak efektif karena belum memiliki jalur khusus. Terlebih waktu pengangkutan di pagi hari juga tergolong kurang efektif.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Menurut Djoko, truk pengangkut sampah semestinya dilengkapi dengan penutup agar sampah tidak terbang dan jatuh ke jalan. Selain itu, adanya penutup juga setidaknya menyelamatkan hidung pengguna jalan yang sekiranya akan mual menciup bau busuk dari truk sampah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Jangan mentang-mentang tempat sampah, jadi kotor,” celotehnya. Selesai melaksanakan tugas 1 ritase sebaiknya truk langsung dibersihkan agar kembali mengangkut dengan kondisi yang bersih, tidak menimbulkan bau di jalan raya.</motion.p>
          
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="font-serif font-bold text-xl sm:text-3xl text-center w-3/4 mx-auto mt-8"
            >
              “Jangan mentang-mentang truk sampah, mobilnya kayak sampah”
            </motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} 
              className="text-base text-center w-3/4 mx-auto mt-2 mb-8"
            >
              -Djoko Setijowarno
            </motion.p>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Kendati demikian, Djoko yang memang hobinya melihat transportasi yang berlalu-lalang di jalan raya ini menilai bahwa seharusnya ada perawatan dan operasional khusus jika ingin lebih baik lagi.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain membersihkan truk dengan air bersih agar terhindar dari korosi dan menggunakan penutup, jam operasional atau pengangkutan menurutnya juga sebaiknya bisa di revisi. “Diupayakan truk-truk sampah itu jangan turun dalam kemacetan. Mungkin perlu jalur-jalur tertentu sehingga menghindari macet. Paling tidak malam hari (karena) tidak begitu macet. Bekerja di malam hari lebih nyaman. Ketimbang harus di pagi hari, panas, dan sebagainya,” lanjut Djoko.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Selain itu, Djoko juga berbicara mengenai perawatan truk yang semestinya. “Kalau aturannya harus uji kir itu setiap enam bulan sekali. Meriset kondisi, setiap sebelum berangkat, diperiksa oli, pengeremannya. Soalnya pernah terjadi truk sampah blong. Pistol remnya blong, tidak berfungsi mengakibatkan kecelakaan. Itu jangan sampai seperti itu,” pungkansya.</motion.p>
          </div>

          <motion.img loading="lazy" src={"../image/transport1.png"} className="h-32 sm:h-[25vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/transport2.png"} className="h-32 sm:h-[25vw] absolute right-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img
            src={"../image/bg12.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div> 

        {/* Section */}
        <div className="w-full min-h-screen overflow-hidden relative flex flex-col items-center text-blue-600 bg-blue-100 z-30">
          <div className="mt-16 pb-4 px-6 lg:mt-8 font-kanit z-50 mb-36 sm:mb-[300px] md:mb-[500px] xl:mb-[600px] text-justify text-base md:text-lg max-w-[90vw] md:max-w-[800px] mx-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Melihat permasalahan yang begitu banyak dan mungkin runyam, saya penasaran dengan tanggapan dari pihak terkait.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8 text-center font-bold px-4 py-2 text-2xl rounded-xl bg-blue-50 border-2 border-blue-500">Apa tanggapan pemerintah?</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8 text-center font-bold">MEIDI NUGROHO ADI, ANALIS PENGEMBANGAN DAN PELAKSANA BIDANG KEBERSIHAN DAN PENGELOLAAN SAMPAH DI DINAS LINGKUNGAN HIDUP KOTA TANGERANG</motion.p>
            
            <motion.div
              className="w-[90%] mx-auto mb-8 md:w-1/2 z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/Meidi.jpeg"} className="mx-auto w-full px-4" alt="bg"/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.div
              className="mb-4 z-30 cursor-pointer"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 }
              }}
            >
              <audio ref={audioRef4}>
                <source src="../audio/Meidi.MP3" type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <img loading="lazy" src={"../image/play.png"} className="w-12 hover:scale-125 transition-all" alt="bg" onClick={togglePlayPause4}/>
              {/* <h3 className="text-center font-kanit text-base md:text-lg">Sampah dalam truk</h3> */}
            </motion.div>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Meidi Nugroho Adi adalah pihak yang paham betul mengenai truk sampah Kota Tangerang yang beroperasi setiap harinya. Ia menjelaskan terdapat beberapa jenis armada yang digunakan untuk mengangkat sampah se-antero Kota Tangerang.</motion.p>
              
            <iframe 
              src='https://flo.uri.sh/visualisation/17927764/embed'
              title='Interactive or visual content'
              className='flourish-embed-iframe rounded-xl mb-8'
              frameborder='0'
              scrolling='no'
              style={{ width: '100%', height: '600px' }}
              sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
            </iframe>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Truk sampah yang biasa ditemukan di jalan raya dengan kernet berjenis <i>dump truck</i>. Memiliki spesifikasi serupa dengan truk pasir dan truk barang lainnya, tidak ada spesifikasi khusus yang digunakan walau dipakai untuk mengangkut sampah.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Kapasitas dan volume bak sampah adalah enam meter kubik, tapi dalam penerapannya sering tidak berstandar. Maksudnya adalah sampah yang sudah penuh dan tidak lagi muat di dalam bak akan terus dipaksakan menggunakan papan hingga terlihat sangat tinggi dan mungkin saja melebihi kapasitas maksimal, empat ton.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Jam operasional pengangkutan sampah dimulai pada jam setengah lima pagi. Rute pertama, <i>dump truck</i> akan melewati jalur protokol atau jalur yang ada di pinggir jalan raya. Kemudian, selesai sekitar jam delapan pagi dan kembali lagi bekerja untuk ritase kedua yang melayani kompleks dan perusahaan.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Meidi sendiri mengakui bahwa untuk jam pulang sopir dan kernet tidak pasti. Hal ini berkaitan dengan kepadatan jalan di TPA. Jika TPA macet, bisa saja pengangkutan selesai pada malam hari, tetapi jika TPA lancar, tentu sore hari pun sudah selesai.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Masalah yang ditemukan pada truk sampah dibenarkan oleh Meidi sendiri. Pasalnya, anggaran yang dimiliki oleh Dinas Lingkungan Hidup Kota Tangerang tidak mencukupi. Oleh sebab itu, perawatan truk sampah tidak maksimal.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Berdasarkan Standar Satuan Harga Nasional (SSL) seharusnya satu truk sampah memiliki anggaran sebanyak Rp57 juta per tahun.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">“Cuma kendalanya di pemerintahan ini kembali lagi soal anggaran. Belum satu armada, satu slot anggaran. Masih terbatas jadi masih saling silang. Bisa jadi satu anggaran untuk dua mobil, bisa untuk tiga gitu. Belum betul-betul satu persatu dianggarkan,” ungkap Meidi.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Kendati demikian, walau memiliki berbagai masalah, pihak dari Dinas Lingkungan Hidup Kota Tangerang selalu melakukan evaluasi agar bisa memberikan pelayanan yang lebih baik lagi kepada masyarakat.</motion.p>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="mb-8">Dilihat dari permasalahan yang begitu banyak mengenai truk sampah yang digunakan, saya menemukan bahwa permasalahan utama terletak pada anggaran yang dimiliki. Jika Dinas Lingkungan Hidup Kota Tangerang memiliki anggaran yang cukup, yaitu Rp57 juta untuk satu armada, kondisi truk sampah tidak akan usang.</motion.p>
          </div>

          <motion.img loading="lazy" src={"../image/pns1.png"} className="h-32 sm:h-[25vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1 },
              x: { duration: 0.5, delay: 1 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/pns2.png"} className="h-32 sm:h-[25vw] absolute right-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.5 },
              x: { duration: 0.5, delay: 1.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg10.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div>
        <div className="w-full h-screen overflow-hidden relative flex flex-col items-center justify-center text-blue-600 bg-blue-100 z-30">
          <div className="flex flex-col items-center justify-center font-kanit z-50 text-base md:text-lg m-auto">
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 } }} className="p-24 xl:p-[50vmin] mb-8 text-center z-20 rounded-[9999px] bg-[radial-gradient(rgba(255,255,255,0.97)_55%,rgba(255,255,255,0)_70%)] xl:bg-[radial-gradient(rgba(255,255,255,0.97)_40%,rgba(255,255,255,0)_70%)]">Sudah bertahun-tahun, truk sampah Kota Tangerang beroperasi dalam kondisi yang usang. <a href="https://banten.antaranews.com/berita/276345/dlh-kota-tangerang-jadikan-pengelolaan-sampah-program-prioritas" target="_blank" rel="noreferrer"><u>Februari lalu, Dinas Lingkungan Hidup Kota Tangerang mengeklaim</u></a> akan menjadikan pengelolaan sampah sebagai program utama. Diharapkan, moda pengangkut sampah di kota ini juga dapat ditingkatkan. Upaya ini tidak hanya bertujuan untuk memperbaiki kualitas pengelolaan sampah, tetapi juga untuk meningkatkan mutu hidup warga Kota Tangerang.</motion.p>
            <motion.img
              src={"../image/background.webp"}
              className={ windowWidth < (windowHeight+768) ? "h-screen w-auto absolute right-0 bottom-0 object-cover z-10" : "w-screen h-auto absolute right-0 bottom-0 object-cover z-10"} alt="bg"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 }
              }}
              viewport={{ once: true }}
            />
          </div>
        </div>

        <div className="w-full h-96 overflow-hidden relative flex flex-row items-center text-blue-600 bg-teal-600 border-t-8 border-blue-600 z-30">
          <div className="px-6 font-kanit z-50 text-justify text-base md:text-lg w-[90vw] md:w-[1200px] h-full mx-auto sm:m-auto flex flex-col-reverse sm:flex-row-reverse justify-evenly items-center z-10">
            <motion.img
              src={"../image/bg1.png"} className="h-32 md:h-48 lg:h-64 object-cover z-0" alt="bg"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 0.5 }
              }}
              viewport={{ once: false }}
            />
            <div className="flex flex-col text-white">
              <motion.p initial={{ opacity: 0, x: "30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.1 }, x: { duration: 0.5, delay: 0.1 } }} className="">PRODUCER</motion.p>
              <motion.p initial={{ opacity: 0, x: "-30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.1 }, x: { duration: 0.5, delay: 0.1 } }} className="font-kanit mb-2 md:mb-4">Jennifer Carorine Gouw</motion.p>
              <motion.p initial={{ opacity: 0, x: "30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 }, x: { duration: 0.5, delay: 0.2 } }} className="">CONTENT WRITER</motion.p>
              <motion.p initial={{ opacity: 0, x: "-30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.2 }, x: { duration: 0.5, delay: 0.2 } }} className="font-kanit mb-2 md:mb-4">Jennifer Carorine Gouw</motion.p>
              <motion.p initial={{ opacity: 0, x: "30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.3 }, x: { duration: 0.5, delay: 0.3 } }} className="">WEB DEVELOPER</motion.p>
              <motion.p initial={{ opacity: 0, x: "-30px" }} whileInView={{ opacity: 1, x: 0 }} transition={{  type: "spring", opacity: { duration: 1, delay: 0.3 }, x: { duration: 0.5, delay: 0.3 } }} className="font-kanit mb-2 md:mb-4">Vallencius Gavriel Alfredo Siswanto</motion.p>
              
            </div>
          </div>
        </div>

        {/* Section 3 */}
        {/* <div className="w-full min-h-screen overflow-x-hidden relative flex justify-center text-orange-700 bg-orange-100 z-30">
          <h2 className="text-base sm:text-2xl font-kanit-semibold mt-8">
            Kutipan Warga yang Tidak Senang
          </h2>
          <motion.img loading="lazy" src={"../image/annoyed2.png"} className="h-32 sm:h-72 absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/annoyed1.png"} className="h-32 sm:h-72 absolute right-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img
            src={"../image/bg6.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div> */}

        {/* Section 4 */}
        {/* <div className="min-h-screen md:min-h-[130vh] flex flex-col items-center relative">
          <h2 className="text-base sm:text-2xl font-kanit-semibold mt-8 z-30">
            POV Penulis
          </h2>
          <motion.img
            src={"../image/sun.png"} className="w-screen absolute top-0 xl:top-[-40vh] object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "-20vw", x: 0 }}
            whileInView={{ opacity: 1, y: 0, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 10 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg4.png"} className="w-screen absolute right-[40%] bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg4.png"} className="w-screen absolute -right-1/2 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, x: "10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div> */}

        {/* Section 5 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex justify-center text-blue-600 bg-green-100 z-30">
          <h2 className="text-base sm:text-2xl font-kanit-semibold mt-8 text-center mx-4">
            Data Armada Pengangkut Sampah Milik DLH Kota Tangerang
          </h2>
          <motion.img loading="lazy" src={"../image/mobil3.png"} className="h-[15vw] absolute left-[10vw] bottom-[5.8vw] z-30" alt="bg"
            initial={{ opacity: 0, x: "-10vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img loading="lazy" src={"../image/mobil5.png"} className="h-[15vw] absolute right-[10vw] bottom-[2vw] z-30" alt="bg"
            initial={{ opacity: 0, x: "-50vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 4 }
            }}
          />
          <motion.img
            src={"../image/bg7.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: false }}
          />
        </div> */}

        {/* Section 6 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex justify-center text-blue-600 bg-orange-100 z-30">
          <h1 className="font-kanit-semibold text-orange-500 text-lg lg:text-3xl mt-12">Rute Perjalanan Truk Sampah</h1>
          <motion.div className="w-[90%] sm:w-[50vw] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-row items-center z-50"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              opacity: { duration: 2 }
            }}
            viewport={{ once: false }}
          >
            {
              selectedCity === 0 &&
              <video className="w-[80%] mx-auto" autoPlay loop controls>
                <source src="../video/sampah1.mp4" type="video/mp4"/>
                Your browser does not support the video.
              </video>
            }
            {
              selectedCity === 1 &&
              <video className="w-[80%] mx-auto" autoPlay loop controls>
                <source src="../video/sampah1.mp4" type="video/mp4"/>
                Your browser does not support the video.
              </video>
            }
            {
              selectedCity === 2 &&
              <video className="w-[80%] mx-auto" autoPlay loop controls>
                <source src="../video/sampah1.mp4" type="video/mp4"/>
                Your browser does not support the video.
              </video>
            }
            {
              selectedCity === 3 &&
              <video className="w-[80%] mx-auto" autoPlay loop controls>
                <source src="../video/sampah1.mp4" type="video/mp4"/>
                Your browser does not support the video.
              </video>
            }
            {
              selectedCity === 4 &&
              <video className="w-[80%] mx-auto" autoPlay loop controls>
                <source src="../video/sampah1.mp4" type="video/mp4"/>
                Your browser does not support the video.
              </video>
            }
            <div className="absolute top-[-25%] lg:top-[-15%] w-full text-center lg:text-2xl font-kanit-semibold">
              <Dropdown
                value={selectedCity}
                options={cities}
                onChange={(e) => setSelectedCity(e.value)}
                placeholder="Pilih Rute"
                className="w-fit mx-auto px-6 py-1 bg-blue-200 space-x-4 rounded-full customDropdown"
              />
            </div>
          </motion.div>
          <motion.img
            src={"../image/bg5.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div> */}

        {/* Section 7 */}
        {/* <div className="w-full min-h-screen sm:min-h-[130vh] overflow-hidden relative flex justify-center text-blue-600 bg-[#c3eefe] z-30">
          <h1 className="font-kanit-semibold text-center text-lg lg:text-3xl mt-12 mx-4">Sampah masih belum efektif karena di pinggir jalan Kota Tangerang masih sering terlihat sampah menumpuk yang tidak diambil</h1>
          <motion.img loading="lazy" src={"../image/sampah3.png"} className="h-[10vw] absolute right-[10vw] bottom-[5vw] z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.5 },
              y: { duration: 0.5, delay: 1.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/sampah2.png"} className="h-[10vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.6 },
              y: { duration: 0.5, delay: 1.6 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/sampah4.png"} className="h-[10vw] absolute left-[40%] transform -translate-x-1/2 bottom-[7vw] z-30" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.7 },
              y: { duration: 0.5, delay: 1.7 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg8.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div> */}

        {/* Section 8 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex flex-col items-center justify-center text-blue-600 bg-[#3c4959] z-30 py-8">
          <div className="flex flex-row">
            <div className="w-[40vw] hidden md:block"></div>
            <motion.div
              className="w-full mt-4 md:w-[40vw] left-[10vw] bottom-[5.8vw] z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5 },
                x: { duration: 4 }
              }}
            >
              <img loading="lazy" src={"../image/sampah.jpg"} className="mx-auto w-3/5" alt="bg"/>
              <h3 className="text-center font-kanit text-base md:text-lg text-white">Sampah dalam truk</h3>
            </motion.div>
          </div>
          <div className="flex flex-row">
            <motion.div
              className="w-full mt-4 md:w-[40vw] left-[10vw] bottom-[5.8vw] z-30"
              initial={{ opacity: 0, x: "-10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.2 },
                x: { duration: 4, delay: 0.2 }
              }}
            >
              <img loading="lazy" src={"../image/sampah.jpg"} className="mx-auto w-3/5" alt="bg"/>
              <h3 className="text-center font-kanit text-base md:text-lg text-white">Sampah dalam truk</h3>
            </motion.div>
            <div className="w-[40vw] hidden md:block"></div>
          </div>
          <div className="flex flex-row">
            <div className="w-[40vw] hidden md:block"></div>
            <motion.div
              className="w-full mt-4 md:w-[40vw] left-[10vw] bottom-[5.8vw] z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.4 },
                x: { duration: 4, delay: 0.4 }
              }}
            >
              <img loading="lazy" src={"../image/sampah.jpg"} className="mx-auto w-3/5" alt="bg"/>
              <h3 className="text-center font-kanit text-base md:text-lg text-white">Sampah dalam truk</h3>
            </motion.div>
          </div>
        </div> */}

        {/* Section 9 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex justify-center text-blue-600 bg-blue-100 z-30">
          <h1 className="font-kanit-semibold text-center text-lg lg:text-3xl mt-12 mx-4">Tanggapan Pengamat Lingkungan</h1>
          <motion.img loading="lazy" src={"../image/orang8.png"} className="h-[15vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1 },
              x: { duration: 0.5, delay: 1 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg9.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div> */}

        {/* Section 10 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex items-center justify-center text-blue-600 bg-orange-100 z-30">
          <div className="flex flex-row">
            <motion.div
              className="w-full mt-4 md:w-[70vw] left-[10vw] bottom-[5.8vw] z-30"
              initial={{ opacity: 0, x: "10vw" }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{
                type: "spring",
                opacity: { duration: 0.5, delay: 0.4 },
                x: { duration: 4, delay: 0.4 }
              }}
            >
              <img loading="lazy" src={"../image/sampah.jpg"} className="mx-auto w-3/5" alt="bg"/>
              <h3 className="text-center font-kanit-semibold text-base md:text-lg text-orange-600">Sampah dalam truk</h3>
            </motion.div>
          </div>
        </div> */}

        {/* Section 11 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex items-center justify-center text-blue-600 bg-blue-100 z-30">
          <h1 className="text-center">Cerita Naratif Sastra 3 Korban Dari Truk Sampah <br/> On Going</h1>
        </div> */}

        {/* Section 12 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex items-center justify-center text-blue-600 bg-orange-100 z-30">
          <h1 className="text-center">Cerita Naratif Sastra Supir yang Pernah Mengalami Kejadian Tidak Mengenakan Saat Mengendari Truk <br/> On Going</h1>
        </div> */}

        {/* Section 13 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex flex-col items-center text-blue-600 bg-blue-100 z-30">
          <h1 className="text-center mt-8">Tanggapan Pemerintah</h1>
          <motion.iframe
            className="w-screen h-[50vw] md:w-full md:h-[25vw] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"
            src="https://www.youtube.com/embed/g8L8H_mfYLs?si=7U8XwSj6v3G8mFNW"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              type: "spring",
              opacity: { duration: 1, delay: 1 }
            }}
            viewport={{ once: false }}
          ></motion.iframe>
          <motion.img loading="lazy" src={"../image/pns1.png"} className="h-[20vw] absolute left-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1 },
              x: { duration: 0.5, delay: 1 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/pns2.png"} className="h-[20vw] absolute right-[10vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "7vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5, delay: 1.5 },
              x: { duration: 0.5, delay: 1.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg10.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div> */}

        {/* Section 14 */}
        {/* <div className="w-full min-h-screen overflow-hidden relative flex flex-col items-center text-blue-600 bg-orange-100 z-30">
          <h1 className="font-kanit-semibold text-center text-xl mt-8">Kembali ke Pandangan Pengamat Lingkungan Tentang Saran dan Solusi Kepada Pihak Pemerintah</h1>
          <motion.img loading="lazy" src={"../image/orang9.png"} className="h-[30vw] absolute left-[5vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "-3vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 0.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img loading="lazy" src={"../image/orang10.png"} className="h-[30vw] absolute right-[5vw] bottom-0 z-30" alt="bg"
            initial={{ opacity: 0, x: "3vw" }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              x: { duration: 0.5 }
            }}
            viewport={{ once: false }}
          />
          <motion.img
            src={"../image/bg11.png"} className="w-screen absolute right-0 bottom-0 object-cover z-10" alt="bg"
            initial={{ opacity: 0, y: "10vw" }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              opacity: { duration: 0.5 },
              y: { duration: 2 }
            }}
            viewport={{ once: true }}
          />
        </div> */}
      </div>
      <style>
        {`
            .p-dropdown-panel {
              background-color: rgb(189 230 250);
              padding: 10px;
              color: black;
              border-radius: 20px;
              border: 1px solid gray;
            }
            .teks-title {
              text-transform: uppercase;
              @include center;
              -webkit-text-stroke: 3px #0c83bd;
              color: rgb(242, 242, 255);
              &:after {
                content: $random-text;
                z-index: -1;
                position: absolute;
                color: transparent;
                -webkit-text-stroke-width: 110px * 0.05;
                -webkit-text-stroke-color: darken(#0c83bd, 40%);
                top: -5%;
                left: -0.5%;
              }
            }
            @media only screen and (max-width: 600px) {
              .teks-title {
                -webkit-text-stroke: 0px #0c83bd;
                color: #0c83bd;
              }
            }
            .text-justify {
              text-align: justify;
              text-justify: inter-word;
            }
        `}
      </style>
    </div>
  );
}

export default App;
